// Deactivated = switched off by the merchant/admin (status INACTIVE); sold out is a separate stock state.
// The server enforces the same rule on every cart/checkout path (backend routers/customer/cart.py:is_orderable).
export function isDeactivated(product) {
    return product?.status === "INACTIVE";
}

const RESUME_AT = new Intl.DateTimeFormat("en-IN", {
    timeZone: "Asia/Kolkata", weekday: "short", hour: "numeric", minute: "2-digit",
});

/** Merchant-facing line under a switched-off product: who turned it off and whether it comes back by itself. */
export function availabilityNote(product) {
    if (!isDeactivated(product)) return "";
    if (product.paused_by === "ADMIN") return "Turned off by admin";
    if (product.paused_until) return `Back on automatically ${RESUME_AT.format(new Date(product.paused_until))}`;
    return "Off until you turn it on";
}
